import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function FixData(myStr){
  myStr = myStr.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  return myStr;
}

function GuideShop() {
  const classes = useStyles();
  const shopListAry = [
    'hachinohe',
    'gonohe-shingou',
    'sannohe-nangou-takko-hashikami',
    'misawa-oirase-rokunohe-rokkasho',
    'towada-shichinohe',
    'touhoku',
    'noheji-yokohama',
    'mutsu-higashidoori',
    'aomori',
    'hirono',
    'kuji-noda',
    'karumai-kunohe',
    'ninohe-ichinohe',
  ];
  const shopRangeAry = [
    '八　戸',
    '五戸・新郷',
    '三戸・南部・田子・階上',
    '三沢・おいらせ・六戸・六ケ所',
    '十和田・七戸',
    '東　北',
    '野辺地・横浜',
    'むつ・東通',
    '青　森',
    '洋　野',
    '久慈・野田',
    '軽米・九戸',
    '二戸・一戸',
  ];
  let shopList = "";
  let json = "";
  let shopRange = "";
  let shopListObjAry = [];
  let shopListObj = "";
  
  for (var i in shopListAry){
    json = require("./data/shop/" + shopListAry[i] + ".json");
    shopList = json.map((shop, index) =>
      <Grid item xs={12} md={4} key={index}>
        <Typography className="font-weight-bold my-1" variant="subtitle1" component="h2">
          {FixData(shop.name)}
        </Typography>
        <Divider />
        <div><LocalShippingIcon className="px-1" />{shop.area}</div>
        <div><PhoneEnabledIcon className="px-1" />{shop.tel}</div>
      </Grid>
    );
    shopRange = (
      <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
        {shopRangeAry[i]}
      </Typography>
    );
    shopListObj = (
      <Box my={8}>
        {shopRange}
        <Grid className="px-3" spacing={4} container direction="row" justify="left">
          {shopList}
        </Grid>
      </Box>
    );
    shopListObjAry.push(shopListObj);
  }

  return (
    <div className={classes.root}>
      <div className="wraper">
        <a id="koudoku" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ご購読はこちら
          </Typography>
          インターネットからご購読を希望する方は、下のボタンをクリックして、専用フォームからお申し込みください。
          <Box my={4} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                {/* <CustomButton href="https://backend.daily-tohoku.news/subscribeForm/" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  ご購読申し込み
                </CustomButton> */}
                <CustomButton href="https://www.daily-tohoku.news/subscribeForm" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  ご購読申し込み
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
          フリーダイヤルからご購読を希望する方は、下記の番号からお願いします。<br />
          <div className="border-dark bg-white p-3">
            <Typography className="font-weight-bold line180" variant="h6" component="h2">
              <PhoneEnabledIcon /> 0120-365-339<br />
            </Typography>
            （受付：平日の午前９時３０分～午後５時３０分）<br />
          </div>
          <br />
          ※宅配できるエリアは原則、青森県南地方と岩手県北地方です。<br />
          地域によっては郵送でのお届けとなり、郵便局の配達の都合上、２日以上のお時間がかかります。<br />
          東京都内（新宿、渋谷、中央、港、文京、台東の各区）の一部地域では通常の購読料で翌日配達が可能です。（詳細は（株）全販＝電話<a href="tel:03-5226-5450">03(5226)5450</a>=、<a href="http://www.zempan-group.co.jp/" target="_blank">http://www.zempan-group.co.jp/</a>まで）<br />
          <div className="border-dark bg-white p-3">
            <Typography className="font-weight-bold line180" variant="subtitle1" component="h2">
              購読料　　月ぎめ　3300円（消費税込み）<br />
              郵送購読　月ぎめ　4900円（消費税込み）<br />
            </Typography>
          </div>
          <br />
          お客さまにご記入いただいた個人情報は、担当する販売店に連絡させていただいた上で、デーリー東北新聞社および当該販売所において適切な管理体制で保管いたします。配達、集金、各種ご連絡のほか、各種サービスや関連商品等のご案内などに利用させていただくことがあります。
        </Box>
        
        <a id="shidoku" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ご試読はこちら
          </Typography>
          
          これまでデーリー東北を定期購読されたことのない方で、試しに読んでみたいというお客さまに、７日間無料でお届けいたします。<br />
          ※試読は原則１回限り。配達エリアは青森県南地方、岩手県北地方です。<br />
          <div class="text-danger font-weight-bold my-3">
            誠に申し訳ございませんが、令和７年１２月１６日（火）から令和８年１月５日（月）まで試読のお申し込みを休止いたします。<br/>
          </div>
          
          
          {/* 
          <Box my={4} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                                
                <CustomButton href="https://form.daily-tohoku.org/shidoku" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  ご試読申し込み
                </CustomButton>
                
              </Grid>
            </Grid>
          </Box>
          */}
          
          <div className="border-dark bg-white p-3">
            <Typography className="font-weight-bold line180" variant="subtitle1" component="h2">
              <PhoneEnabledIcon /> フリーダイヤル　0120-365-339<br />
              <MailOutlineIcon /> 電子メール　　　<a href="mailto:hanbai@daily-tohoku.co.jp">hanbai@daily-tohoku.co.jp</a><br />
            </Typography>
          </div>
        </Box>

        <Box my={8}>
          午後４時００分以降のご購読・試読のお申し込みは、翌々日からの配達となります。
          なお土曜・日曜、祝日等にインターネット、電子メールでご購読・試読のお申し込みをいただいた場合、販売店への手配が休み明けとなります。ご了承ください。翌日からの配達を希望する方は、お住まいのエリアの販売店へ直接お電話ください。<br />
          <Box my={4} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="#shop-list" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  販売店一覧
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                {/*
                <CustomButton href="http://feature.daily-tohoku.co.jp/web2/company/form/addr-change/index.php" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  新聞配達先住所の変更
                </CustomButton>
                */}
                <CustomButton href="https://form.daily-tohoku.org/addr-change" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  新聞配達先住所の変更
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デジタル新規会員はこちら
          </Typography>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://www.daily-tohoku.news/user-guide" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            読者紹介キャンペーン
          </Typography>
          新規にデーリー東北を６カ月以上月決め購読契約していただける方をご紹介くださるとJTBナイスギフト5,000円分または、日専連ギフトカード5,000円分をプレゼント。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://www.daily-tohoku.news/dokusha-cp" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  読者紹介キャンペーン
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北デジタル単独コース<br />読者紹介キャンペーン
          </Typography>
          本紙の配達エリア外にお住まいで新規にデーリー東北デジタルを３カ月以上購読契約していただける方をご紹介くださるとJTBナイスギフト5,000円分をプレゼント。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://www.daily-tohoku.news/dokusha-digi-cp" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  デーリー東北デジタル単独コース<br />読者紹介キャンペーン
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            配達員募集
          </Typography>
          　デーリー東北の“最終ランナー”として働いてみませんか。<br/>
          　配達エリア、業務時間などは下記販売店にお問い合わせ下さい。<br/>
          {/*
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://www.q-delisunday.com/daily-hanbai201904-2-2-2-2-2-2-2-2-2-2-2-2-2-2-2-2-2-3-2-2-2-2-2-3-2-2-2-2/" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
          */}
        </Box>

        <a id="shop-list" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            販売店一覧
          </Typography>
          {shopListObjAry}
        </Box>

      </div>
    </div>
  );
}
export default GuideShop;

